// Generado por scripts/gen-version.mjs. No editar ni versionar.
export const APP_VERSION = {
  "version": "1.24.0",
  "build": "9dedc754",
  "env": "production",
  "builtAt": "2026-11-03T04:25:01.147Z"
} as { version: string; build: string; env: string; builtAt: string };
